export default __webpack_public_path__ + "static/media/svg-5.2f879af4.svg";